/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum SessionInputDataTypePaypalEnum {
  "paypal" = "paypal"
}

/**
 * Discriminator used to identify session input data for paypal onboarding
 */

export type SessionInputDataTypePaypal = t.TypeOf<
  typeof SessionInputDataTypePaypal
>;
export const SessionInputDataTypePaypal = enumType<
  SessionInputDataTypePaypalEnum
>(SessionInputDataTypePaypalEnum, "SessionInputDataTypePaypal");
